/*global chrome*/
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
class FameWallPte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
    this.sliderRef = React.createRef();
  }

  render() {
    const pteSlider = {
      dots: true,
      arrows: true,
      // infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    return (
      <>
        <div className="our-champions-heading fm-commendable-heading">
          <div className="container">
            <h2 className="row">
              <h2
                className="primary-heading text-center"
                dangerouslySetInnerHTML={{ __html: this.props.title }}
              />
            </h2>
          </div>
        </div>
        <div className="our-champions-pte">
          <div className="pte-slider">
            <Slider {...pteSlider}>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/1.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/2.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/3.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/4.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/5.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/6.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/7.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/8.jpg" alt="LA" />
                </div>
              </div>
              <div>
                <div className="img-wrapper">
                  <img src="/images/web-new-images/ielts/9.jpg" alt="LA" />
                </div>
              </div>
            </Slider>
          </div>
          <div className="d-flex justify-content-center">
            <Link className="primary-btn" to="/scorecard">
              <span className="btn-inner">
                VISIT OUR WALL OF FAME{" "}
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </span>
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default FameWallPte;
